/* Teslong collection page (v1.1). Everything works without JS: filters/sort submit via <noscript> button,
 * add-to-cart posts to /cart/add. JS adds: sticky offset, auto-submit, mobile drawer, async add-to-cart, intro clamp,
 * and in guide mode: use-case filters, product finder, picks scroller, section nav, compare-table hint. */
(function () {
  var root = document.querySelector('[data-tl-collection]');
  if (!root) return;

  /* 0. Sticky site header offset -> --tl-top on the section */
  var siteHeader = document.querySelector('.site-header');
  function measureTop() {
    var cs = siteHeader ? getComputedStyle(siteHeader) : null;
    var top = cs && (cs.position === 'sticky' || cs.position === 'fixed') ? siteHeader.offsetHeight : 0;
    document.documentElement.style.setProperty('--tl-top', top + 'px');
    return top;
  }
  // the theme makes its header sticky after load, so re-measure on load and while scrolling
  var topOffset = measureTop();
  window.addEventListener('resize', function () { topOffset = measureTop(); });
  window.addEventListener('load', function () { topOffset = measureTop(); });
  window.addEventListener('scroll', function () { if (!topOffset) topOffset = measureTop(); }, { passive: true });

  /* 1. Toolbar shadow once stuck */
  var bar = root.querySelector('[data-tl-toolbar]');
  if (bar) {
    var onScroll = function () { bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= topOffset + 0.5 && window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 2. Intro: clamp to 3 lines with a Read more toggle when it overflows */
  var intro = root.querySelector('[data-tl-intro]');
  if (intro) {
    var txt = intro.firstElementChild, btn = intro.querySelector('[data-tl-intro-toggle]');
    intro.classList.add('is-clamped');
    if (txt.scrollHeight > txt.clientHeight + 4) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = intro.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : 'Read more';
      });
    } else {
      intro.classList.remove('is-clamped');
    }
  }

  /* 3. Filters: submit on change; one desktop dropdown open at a time; mobile drawer */
  var form = root.querySelector('[data-tl-filter-form]');
  if (form) {
    var submit = function () {
      Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (i) { if (i.value === '') i.disabled = true; });
      form.submit();
    };
    // desktop: apply on every change; mobile drawer: collect several choices, apply with "Show results"
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-tl-autosubmit]') && !form.classList.contains('is-open')) submit();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    var groups = form.querySelectorAll('[data-tl-fgroup]');
    var isDrawer = function () { return form.classList.contains('is-open'); };
    Array.prototype.forEach.call(groups, function (g) {
      g.addEventListener('toggle', function () {
        if (!g.open || isDrawer()) return;
        Array.prototype.forEach.call(groups, function (o) { if (o !== g) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (isDrawer() || e.target.closest('[data-tl-fgroup]')) return;
      Array.prototype.forEach.call(groups, function (g) { g.open = false; });
    });

    var openBtn = root.querySelector('[data-tl-drawer-open]');
    // the drawer is moved to <body> while open so no theme stacking context (sticky header, main) can sit above it
    var slot = document.createComment('tl-filters');
    form.parentNode.insertBefore(slot, form);
    var setDrawer = function (open) {
      if (open) { form.classList.add('tl-scope'); document.body.appendChild(form); }
      else { slot.parentNode.insertBefore(form, slot.nextSibling); form.classList.remove('tl-scope'); }
      form.classList.toggle('is-open', open);
      if (bar) bar.classList.toggle('has-drawer', open);
      document.documentElement.classList.toggle('tl-noscroll', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        Array.prototype.forEach.call(groups, function (g) { g.open = !!g.querySelector('input:checked') || groups.length <= 2; });
        var c = form.querySelector('[data-tl-drawer-close]'); if (c) c.focus();
      } else if (openBtn) {
        openBtn.focus();
      }
    };
    if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
    Array.prototype.forEach.call(form.querySelectorAll('[data-tl-drawer-close]'), function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (isDrawer()) setDrawer(false);
      else Array.prototype.forEach.call(groups, function (g) { g.open = false; });
    });
  }

  /* 4. Async add to cart + toast + header cart count */
  var toast = root.querySelector('[data-tl-toast]'), toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.querySelector('[data-tl-toast-msg]').textContent = msg;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }
  function updateCount() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        Array.prototype.forEach.call(document.querySelectorAll('[data-header-cart-count], .site-header-cart--count, .cart-count-bubble span, [data-cart-count]'), function (el) {
          // Empire prints the number from the data attribute (CSS attr()); only other themes need textContent
          if (el.hasAttribute('data-header-cart-count')) { el.setAttribute('data-header-cart-count', n); el.textContent = ''; }
          else el.textContent = n;
          el.classList.toggle('visible', n > 0);
        });
      })
      .catch(function () {});
  }
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-tl-atc]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var b = f.querySelector('button');
    b.setAttribute('aria-busy', 'true');
    var label = b.textContent;
    b.textContent = 'Adding…';
    fetch(f.getAttribute('action') + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to cart');
        showToast('Added to cart');
        updateCount();
        if (window.dataLayer) window.dataLayer.push({ event: 'tl_collection_add_to_cart', product: b.getAttribute('data-product') });
      })
      .catch(function (err) { showToast(err.message || 'Could not add to cart'); })
      .then(function () { b.removeAttribute('aria-busy'); b.textContent = label; });
  });

  if (!root.classList.contains('tl-col--guide')) return;
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var smooth = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; };
  function track(name, params) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params || {})); } catch (e) {}
  }

  /* 5. Use-case filters: OR inside a group, AND across groups; cards carry data-app / data-user / data-rec */
  var chips = root.querySelectorAll('.tl-fchip');
  var cards = root.querySelectorAll('[data-tl-card]');
  var countEl = root.querySelector('[data-tl-ucount]');
  var emptyEl = root.querySelector('[data-tl-uempty]');
  if (countEl) countEl.setAttribute('data-total', countEl.textContent);
  function applyFilters() {
    var active = {}, any = false;
    each(chips, function (c) {
      if (c.getAttribute('aria-pressed') !== 'true') return;
      (active[c.dataset.group] = active[c.dataset.group] || []).push(c.dataset.value);
      any = true;
    });
    var shown = 0;
    // with no use-case chip on, the count is the (natively filtered) collection total, not just this page's cards
    if (!any && countEl) { countEl.textContent = countEl.getAttribute('data-total'); }
    each(cards, function (card) {
      var ok = Object.keys(active).every(function (g) {
        var have = (card.getAttribute('data-' + g) || '').split(' ');
        return active[g].some(function (v) { return have.indexOf(v) > -1; });
      });
      card.hidden = !ok;
      if (ok) shown++;
    });
    if (countEl && any) countEl.textContent = shown;
    if (emptyEl) emptyEl.hidden = shown > 0;
    each(root.querySelectorAll('[data-tl-uclear]'), function (b) { if (b.closest('.tl-ufilters')) b.hidden = !any; });
  }
  each(chips, function (c) {
    c.addEventListener('click', function () {
      var on = c.getAttribute('aria-pressed') !== 'true';
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      applyFilters();
      if (on) track('tl_collection_usecase_filter', { group: c.dataset.group, value: c.dataset.value });
    });
  });
  each(root.querySelectorAll('[data-tl-uclear]'), function (b) {
    b.addEventListener('click', function () { each(chips, function (c) { c.setAttribute('aria-pressed', 'false'); }); applyFilters(); });
  });
  // hero chips: show only that use case, then jump to the grid
  each(root.querySelectorAll('[data-tl-apply]'), function (a) {
    a.addEventListener('click', function (e) {
      var kv = a.getAttribute('data-tl-apply').split(':');
      var hit = false;
      each(chips, function (c) {
        var on = c.dataset.group === kv[0] && c.dataset.value === kv[1];
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        hit = hit || on;
      });
      if (!hit) return;
      e.preventDefault();
      applyFilters();
      // land on the result line + toolbar so the first row of matching cards is on screen
      jump(root.querySelector('.tl-ufilters__foot') || document.getElementById('tl-shop'), '#tl-shop');
      track('tl_collection_hero_chip', { filter: kv.join(':') });
    });
  });
  // a hero chip whose landing card is not on the page (e.g. a pick that sold out and was skipped) would do nothing: hide it
  each(root.querySelectorAll('.tl-uchip[href^="#tl-"]:not([data-tl-apply])'), function (a) {
    if (!document.getElementById(a.getAttribute('href').slice(1))) a.closest('li').hidden = true;
  });

  /* 6. Product finder: three answers → scores per product; ties follow the editor's order */
  var finder = root.querySelector('[data-tl-finder]');
  var fdata = root.querySelector('[data-tl-finder-data]');
  if (finder && fdata) {
    var data = {};
    try { data = JSON.parse(fdata.textContent); } catch (e) { data = {}; }
    var answers = {};
    var out = finder.querySelector('[data-tl-finder-result]');
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };
    var opt = function (q, v) {
      var qq = (data.questions || []).filter(function (x) { return x.id === q; })[0];
      return qq && qq.options.filter(function (o) { return o.v === v; })[0];
    };
    var render = function () {
      var qs = data.questions || [], order = data.order || [], prods = data.products || {};
      var scores = {};
      Object.keys(prods).forEach(function (h) { scores[h] = 0; });
      qs.forEach(function (q) {
        var o = opt(q.id, answers[q.id]);
        if (!o) return;
        Object.keys(o.scores || {}).forEach(function (h) { if (h in scores) scores[h] += o.scores[h]; });
      });
      // answers marked "require" (dual lens, 4-way, rotating) keep only products scored for them; a requirement that
      // would leave nothing (e.g. rotating + 4-way) is skipped
      var pool = Object.keys(scores);
      qs.forEach(function (q) {
        var o = opt(q.id, answers[q.id]);
        if (!o || !o.require) return;
        var kept = pool.filter(function (h) { return (o.scores || {})[h] > 0; });
        if (kept.length) pool = kept;
      });
      var ranked = pool.sort(function (a, b) { return (scores[b] - scores[a]) || (order.indexOf(a) - order.indexOf(b)); });
      if (!ranked.length) return;
      var top = prods[ranked[0]];
      var alts = ranked.slice(1, 3).filter(function (h) { return scores[h] > 0; });
      // only give the reasons the recommended model actually meets
      var why = qs.map(function (q) {
        var o = opt(q.id, answers[q.id]);
        return o && (o.scores || {})[ranked[0]] > 0 ? '<li><svg class="tl-gi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 4.5 4.5L19 7"/></svg>' + esc(o.reason) + '</li>' : '';
      }).join('');
      out.innerHTML =
        '<p class="tl-eyebrow tl-rec__lbl">Recommended for you</p>' +
        '<div class="tl-rec">' +
          '<div class="tl-rec__top"><img src="' + esc(top.img) + '" alt="" width="96" height="96" loading="lazy">' +
          '<div><p class="tl-rec__name">' + esc(top.name) + '</p><p class="tl-rec__tag">' + esc(top.tag) + '</p><p class="tl-rec__specs">' + esc(top.specs) + '</p></div></div>' +
          '<ul class="tl-rec__why">' + why + '</ul>' +
          '<div class="tl-rec__foot"><strong>' + esc(top.price) + '</strong><a class="tl-btn tl-btn--dark tl-btn--sm" href="' + esc(top.url) + '" data-tl-rec>View details</a></div>' +
        '</div>' +
        (alts.length ? '<p class="tl-rec__alt">Also worth considering: ' + alts.map(function (h) { return '<a href="' + esc(prods[h].url) + '" data-tl-rec>' + esc(prods[h].name) + '</a>'; }).join(' · ') + '</p>' : '');
      track('tl_collection_finder_result', { answers: qs.map(function (q) { return answers[q.id]; }).join('|'), product: ranked[0] });
    };
    each(finder.querySelectorAll('.tl-opt'), function (b) {
      b.addEventListener('click', function () {
        answers[b.dataset.q] = b.dataset.v;
        each(finder.querySelectorAll('.tl-opt[data-q="' + b.dataset.q + '"]'), function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if ((data.questions || []).every(function (q) { return answers[q.id]; })) render();
      });
    });
  }

  /* 7. Editor's picks: arrow buttons page the scroller */
  var scroller = root.querySelector('[data-tl-scroller]');
  if (scroller) {
    var arrows = root.querySelectorAll('[data-tl-scroll]');
    var updArrows = function () {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      each(arrows, function (b) { b.disabled = b.dataset.tlScroll === '-1' ? scroller.scrollLeft <= 2 : scroller.scrollLeft >= max; });
    };
    each(arrows, function (b) {
      b.addEventListener('click', function () { scroller.scrollBy({ left: Number(b.dataset.tlScroll) * scroller.clientWidth * 0.8, behavior: smooth() }); });
    });
    scroller.addEventListener('scroll', updArrows, { passive: true });
    window.addEventListener('resize', updArrows);
    updArrows();
  }

  /* 8. Section nav + in-page jumps: smooth scroll (sections carry scroll-margin-top), highlight the section in view */
  // The page scroll is computed here from the target's scroll-margin-top rather than left to scrollIntoView (some mobile
  // in-app / Android browsers ignore the margin or stop a long smooth scroll early). Once the scroll settles the target
  // is re-measured for 3.5 s and nudged back to its line: late fonts, images or review widgets above it can push it
  // down, and browsers without scroll anchoring (iOS Safari) do not compensate. Any wheel / touch / key stops this.
  var settleEl = null, settleEnd = 0, settleTimer, lastY = -1;
  function marginOf(el) { return parseFloat(getComputedStyle(el).scrollMarginTop) || 0; }
  function settle() {
    if (!settleEl || Date.now() > settleEnd) { settleEl = null; return; }
    if (window.scrollY !== lastY) { lastY = window.scrollY; settleTimer = setTimeout(settle, 150); return; }
    var off = settleEl.getBoundingClientRect().top - marginOf(settleEl);
    var room = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
    if (Math.abs(off) > 3 && (off < 0 || room > 1)) window.scrollTo({ top: window.scrollY + off, behavior: 'auto' });
    settleTimer = setTimeout(settle, 300);
  }
  function pageTo(el) {
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - marginOf(el), behavior: smooth() });
    settleEl = el; settleEnd = Date.now() + 3500; lastY = -1;
    clearTimeout(settleTimer); settleTimer = setTimeout(settle, 250);
  }
  each(['wheel', 'touchstart', 'keydown'], function (ev) { window.addEventListener(ev, function () { settleEl = null; }, { passive: true }); });
  function jump(t, hash) {
    if (!t) return;
    // a product card hidden by the use-case filters cannot be scrolled to: clear them first
    if (t.hidden && t.hasAttribute('data-tl-card')) { var clr = root.querySelector('.tl-ufilters [data-tl-uclear]'); if (clr) clr.click(); }
    topOffset = measureTop();
    var sc = t.closest('[data-tl-scroller]');
    if (sc) {
      // one scroll per container: the list sideways to the card, the page down to the list (a single scrollIntoView
      // that does both stops the sideways part early on mobile)
      var pad = parseFloat(getComputedStyle(sc).scrollPaddingLeft) || 0;
      sc.scrollTo({ left: t.getBoundingClientRect().left - sc.getBoundingClientRect().left + sc.scrollLeft - pad, behavior: smooth() });
      pageTo(sc);
    } else {
      pageTo(t);
    }
    if (hash) history.replaceState(null, '', hash);
    // cards (use case, product, pick) get a short highlight so the reader sees where they landed
    if (t.matches('.tl-ucase, .tl-gcard, .tl-pick')) {
      t.classList.remove('is-target'); void t.offsetWidth; t.classList.add('is-target');
      setTimeout(function () { t.classList.remove('is-target'); }, 2200);
    }
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#tl-"]');
    if (!a || a.hasAttribute('data-tl-apply')) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    jump(t, a.getAttribute('href'));
  });
  var toTop = root.querySelector('[data-tl-totop]');
  if (toTop) toTop.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: smooth() }); });
  var nav = root.querySelector('[data-tl-gnav]');
  if (nav) {
    var navLinks = Array.prototype.slice.call(nav.querySelectorAll('ul a'));
    var secs = navLinks.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var cur = null, ticking = false;
    var spy = function () {
      ticking = false;
      var line = topOffset + nav.offsetHeight + window.innerHeight * 0.25, best = -1;
      secs.forEach(function (s, i) { if (s && s.getBoundingClientRect().top <= line) best = i; });
      if (best === cur) return;
      cur = best;
      navLinks.forEach(function (a, i) { a.setAttribute('aria-current', i === best ? 'true' : 'false'); });
      var on = navLinks[best], ul = on && on.parentNode.parentNode;
      if (on && ul.scrollWidth > ul.clientWidth) ul.scrollTo({ left: on.offsetLeft - ul.clientWidth / 2 + on.offsetWidth / 2, behavior: 'auto' });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
    spy();
  }

  /* 9. Compare table: "swipe" hint only while columns are cut off */
  each(root.querySelectorAll('[data-tl-ctable]'), function (box) {
    var sc = box.querySelector('.tl-ctable__scroll');
    var upd = function () { box.classList.toggle('is-overflow', sc.scrollWidth > sc.clientWidth + 2 && sc.scrollLeft + sc.clientWidth < sc.scrollWidth - 2); };
    sc.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });
})();
